//Aqui
//Alterar para em projeto/producao e/ou Homolocao
// versao.js basutlaxios.js baseultapi.js api.js e ambiente.js
//const ambiente = "Ambiente Compilação: Homologação"
const ambiente = "Ambiente Compilação: Produção"
export default ambiente
